<!--
 * @Descripttion: 
 * @version: 
 * @Author: jing
 * @Date: 2020-12-15 10:35:17
 * @LastEditors: jing
 * @LastEditTime: 2020-12-15 15:28:55
-->
<template>
  <div class="wrapper">
    <img :src="banner" />
    <!--     <div class="tab-layer">
        <div class="tab" :class="{'active': activeIdx == 1}" @click="chgTab(1)">媒体资讯</div>
        <div class="tab" :class="{'active': activeIdx == 2}" @click="chgTab(2)">媒体解读</div>
    </div> -->
    <!-- 	<div
	  v-for="(item,index) in list"
      :key="index"
	  class="item border-bottom"
	  @click="goDetail($event,item.url)"
	  v-show="item.type == activeIdx"
	> -->
    <div
      v-for="(item, index) in list"
      :key="index"
      class="item border-bottom"
      @click="goDetail($event, item.url)"
    >
      <div class="left-layer">
        <div class="title">
          <!-- <span :class="{ s2: item.type == 1 }">{{
            item.type == 1 ? "媒体资讯" : "媒体解读"
          }}</span> -->
          {{ item.t }}
        </div>
        <div class="desc">{{ item.time }}</div>
      </div>
      <img :src="item.imgsrc" />
    </div>
    <Tabbar12 :seleIndex="0"></Tabbar12>
  </div>
</template>

<script>
import request from "@/utils/request";
import global_ from "../../../../global.config";
import { mapState, mapMutations } from "vuex";
import * as comreq from "@/utils/comreq";
import util from "@/utils/utils";
import Cookies from "js-cookie";
import { project } from "../config";
const Tabbar12 = () => import("@/components/tabbar12");
export default {
  name: "",
  data() {
    return {
      cardUserInfo: {},
      expand: false,
      activeIdx: 1,
      list: [],
      banner: ""
    };
  },
  computed: {
    ...mapState([
      "userInfo",
      "pageInfo",
      "shareSpreadInfo",
      "isInMiniProgram",
      "receiveSpreadInfo"
    ])
  },
  components: { Tabbar12 },
  watch: {},
  methods: {
    setShareInfo() {
      util.checkMapStateCallback(this, ["pageInfo", "userInfo"]).then(() => {
        let saleropenid = this.$route.query.saleropenid;
        if (this.global.isLoc && !saleropenid) {
          saleropenid = this.$openid;
        }
        comreq.getUserInfoAndFansInfo(saleropenid).then(data => {
          this.cardUserInfo = data;
          console.log("销售信息", data);
          this.cardUserInfo.ui.name
            ? (document.title = `中海·映山湖-${
                this.cardUserInfo.ui.name
              }的电子名片`)
            : "";
          util.setFoundShareCustomPageName(
            `我是${this.cardUserInfo.ui.name}，欢迎您随时联系`,
            `手机号：${this.cardUserInfo.ui.mobile} ${
              this.cardUserInfo.ui.wechatno
                ? "微信号：" + this.cardUserInfo.ui.wechatno
                : ""
            }`,
            this.pageInfo,
            this.shareSpreadInfo,
            false,
            `&entry=zxslzx&t9id=${this.$route.query.t9id}&t9psn=${
              this.$route.query.t9psn
            }&saleropenid=${saleropenid}&backhome=home&t9id=${
              this.$route.query.t9id
            }&t9psn=${this.$route.query.t9psn}`,
            this.cardUserInfo.ui.headimg,
            "vcard3/home"
          );
        });
      });
    },
    goDetail(e, url) {
      window.location.href = url;
    },
    changeExpand() {
      this.expand = !this.expand;
    },
    chgTab(type) {
      let that = this;
      if (type == that.activeIdx) {
        return;
      }
      that.activeIdx = type;
    }
  },
  created() {
    this.list = project.list;
    this.banner = project.banner;
    this.setShareInfo();
  }
};
</script>

<style lang="stylus" scoped>
// px 转换 rem
// p2r(designpx) {
//   $rem = 100px;
//   return (designpx / $rem) rem;
// }
// .project-list {
//   width: 100%;
//   background-color: #fff;
//   padding-bottom: p2r(120px);
//   box-sizing: border-box;
// }
.wrapper > img {
  width: 100%;
  display: block;
}
.btn-layer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.btn {
  width: 1rem;
  line-height: 0.5rem;
  color: #1252f0;
  font-size: 16px;
  text-align: right;
  padding-right: 0.2rem;
}
.desc-layer {
  padding: 0.2rem 0.2rem;
  line-height: 0.5rem;
  font-size: 0.28rem;
  height: 1.25rem;
  overflow: hidden;
}
.desc-layer.expand {
  height: auto;
}
.item {
  margin: 0 10px;
  padding: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.item .left-layer {
  flex: 1;
}
.item .left-layer .title {
  font-size: 15px;
  line-height: 0.5rem;
}
.item .left-layer .title > span {
  /*display: block;*/
  font-size: 10px;
  padding: 4px 6px;
  border-radius: 4px;
  background: #3a7af3;
  color: #ffffff;
  margin-right: 5px;
}
.item .left-layer .title .s2 {
  background: #f4a365;
}
.item .left-layer .desc {
  font-size: 13px;
  line-height: 0.5rem;
  color: #999999;
}

.item > img {
  width: 80px;
  height: 80px;
  display: block;
}

.wrapper .tab-layer {
  display: flex;
  align-items: center;
  line-height: 0.8rem;
  height: 0.8rem;
  font-size: 0.28rem;
  color: #666666;
  font-weight: 500;
}

.wrapper .tab-layer .tab {
  flex: 1;
  text-align: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wrapper .tab-layer .tab > span {
  height: 0.8rem;
}

.wrapper .tab-layer .tab.active {
  color: #1696f0;
}

.wrapper .tab-layer .tab.active:after {
  position: absolute;
  content: "";
  width: 1rem;
  height: 3px;
  background-color: #1596f1;
  bottom: 0;
  left: 50%;
  margin-left: -0.5rem;
}
</style>
